import { usePostHogFeatureFlag } from '@hooks/usePostHogFeatureFlag';
import { PostHogFeatureFlags } from '@lib/posthog-feature-flags';

const useNotificationPreferencesFeatureFlag = () =>
  usePostHogFeatureFlag(
    PostHogFeatureFlags.newNotificationPreferencesFlowIsLive,
    false
  );

export default useNotificationPreferencesFeatureFlag;
